export enum PkiType {
  EST = "EST",
  MICROSOFT = "MICROSOFT",
}
